function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 2.75H4.5C3.5335 2.75 2.75 3.5335 2.75 4.5V3C2.75 2.86193 2.86193 2.75 3 2.75ZM19.3333 21.25H18C18.6995 21.25 19.3032 20.8395 19.5833 20.2463V21C19.5833 21.1381 19.4714 21.25 19.3333 21.25ZM4.5 21.25H3C2.86193 21.25 2.75 21.1381 2.75 21V19.5C2.75 20.4665 3.5335 21.25 4.5 21.25Z",
  stroke: "#556677",
  strokeWidth: 1.5
});
var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 6.25,
  x2: 11.25,
  y2: 6.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 10.25,
  x2: 11.25,
  y2: 10.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 14.25,
  x2: 16.25,
  y2: 14.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 18.25,
  x2: 16.25,
  y2: 18.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 8,
  r: 4.45,
  stroke: "#556677",
  strokeWidth: 1.1
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 9.99992C16.5 9.99992 19.5 11.4999 19.5 9.49993C19.5 7.69715 16.5 8.58105 16.5 6.99993C16.5 5.49992 18.5 5.49994 19.5 6.49994",
  stroke: "#556677",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18 11L18 5",
  stroke: "#556677",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgInvoicesDocumentsIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInvoicesDocumentsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/invoices-documents-icon.72510e46.svg";
export { ForwardRef as ReactComponent };